const Login = {
  USER_LOGIN: 'user/login',
  USER_LOGOUT: 'user/logout',
  USER_FORGOT_PASSWORD: 'user/forgot_password',
};

export default Login;
